import { TipologiaContenidoIdiomaFormulario, AnchorPoint } from './../domain/TipologiaContenidoFormulario';
import { Component, EventEmitter, Input, Output, OnDestroy, SimpleChanges, OnChanges } from '@angular/core';

import { EntityManagerProvider } from '../providers/entity-manager-provider/entity-manager-provider';
import { AuthenticationService } from '../providers/authentication/authentication.service';

import { MessageService } from 'primeng/components/common/messageservice';
import { IdiomaService } from '../providers/idioma/idioma.service';
import { ServiciosWebServiceProvider } from '../providers/web-service-service/servicios-web-service';
import { Idioma } from '../domain/Idioma';
import { TranslateService } from 'ng2-translate';
import { Message } from 'primeng/primeng';
import { Predicate } from 'breeze-client';
import { Permisos, PermisosService } from '../providers/authentication/permisos.service';
import { Constantes } from '../domain/constantes';
import { AppComponent } from '../app.component';
import { TipoLocalizacion } from '../domain/TipologiaContenidoFormulario';

@Component({
	selector: 'app-formulario-tipologia-contenido',
	templateUrl: './FormularioTipologiaContenido.component.html',
	providers: [MessageService]
})

export class FormularioTipologiaContenidoComponent implements OnDestroy, OnChanges{
	[x: string]: any;

	@Input() tipologiaSeleccionada: any;
	@Input() edicion: boolean;
	@Input() msgs: Message[] = [];
	@Input() tipologiasExistentes: any[] = [];

	@Output() onElementoGuardado: EventEmitter<any> = new EventEmitter();
	@Output() onElementoError: EventEmitter<any> = new EventEmitter();
	@Output() onElementoEliminado: EventEmitter<boolean> = new EventEmitter();

	imagenTipologiaSeleccionada: any;
	selectorImagenTipologia: any;

	/* IDIOMA */
	idiomas;
	idiomaSeleccionado: Idioma;
	idiomaDefecto: Idioma;

	public confirmacionVisible = false;
	public operacion = '';
	public permisos: Permisos = new Permisos();
	spinner: HTMLElement;

	anchorPoint = Constantes.top_center;
	anchorPoints = [
		new AnchorPoint(Constantes.top_left),
		new AnchorPoint(Constantes.top_center),
		new AnchorPoint(Constantes.top_right),
		new AnchorPoint(Constantes.center_left),
		new AnchorPoint(Constantes.center_center),
		new AnchorPoint(Constantes.center_right),
		new AnchorPoint(Constantes.bottom_left),
		new AnchorPoint(Constantes.bottom_center),
		new AnchorPoint(Constantes.bottom_right)
	];

	tiposLocalizacion = [
		new TipoLocalizacion(this.translate, 'ESTATICO'),
		new TipoLocalizacion(this.translate, 'DIRECTA'),
		new TipoLocalizacion(this.translate, 'INDIRECTA')
	];

	constructor(
		private appComponent: AppComponent,
		private entityManager: EntityManagerProvider,
		public authService: AuthenticationService,
		private wsServices: ServiciosWebServiceProvider,
		private idiomaService: IdiomaService,
		private translate: TranslateService,
		private permisosService: PermisosService) {

		const that = this;

		// Inicializamos Spinner
		this.spinner = document.getElementsByClassName('spinner-container')[0] as HTMLElement;
		this.spinner.style.display = 'none';

		this.entityManager.getIDIOMA()
		.then(function (idiomasENTIDAD: any) {

			that.idiomas = [];

			idiomasENTIDAD.forEach(idioma => {
				if(idioma.Visible === true){
				that.idiomas.push(new Idioma(idioma));
				}
			});

			that.idiomaDefecto = that.idiomaService.getIdiomaDefecto(that.idiomas);
			that.idiomaSeleccionado = that.idiomaDefecto;
			return true;
		})
		.then(function () {
			return that.comprobarPermisos();
		})
		.then(function () {
			// Ocultamos Spinner
			// that.spinner.style.display = 'none';
		});
	}

	ngOnChanges(changes: SimpleChanges): void {
		this.idiomaSeleccionado = this.idiomaDefecto;
		this.confirmacionVisible = false;
		this.onIdiomaChange({value: this.idiomaSeleccionado});
		this.tipologiasExistentes = this.tipologiasExistentes;
	}

	ngOnDestroy(): void {
		this.entityManager.RejectChanges();
	}

	comprobarPermisos() {
		const userId = this.authService.getIdUsuario();
		const that = this;
		return this.permisosService.getPermisosUsuario(userId)
		.then(function(perm: Permisos){
			that.permisos = perm;
		});
	}

	/* ************************************************************************** */
	/*                            COMUN FORMULARIO                                */
	/* ************************************************************************** */

	inputChanged(value) {
		//  Cojemos la traduccion del espacio al idioma seleccionado
		const tipologiaContenidoIdioma = this.tipologiaSeleccionada.Idiomas.get(this.idiomaSeleccionado.ENTIDAD.Codigo);

		// Guardamos los posibles cambios del idioma
		tipologiaContenidoIdioma.Nombre = this.tipologiaSeleccionada.Nombre;

		this.tipologiaSeleccionada.Idiomas.set(this.idiomaSeleccionado.ENTIDAD.Codigo, tipologiaContenidoIdioma);
	}

	public validar(): boolean {
		console.warn('Implementar: validar');
		return true;
	}

	onFileSelectTipologia($event, fileUploadComponent) {
		this.selectorImagenTipologia = fileUploadComponent;
		console.log('$event.files[0] = ' + $event.files[0]);
		this.imagenTipologiaSeleccionada = $event.files[0];
	}

	onRemoveSelect($event?, fileUploadComponent?) {
		this.imagenTipologiaSeleccionada = undefined;
	}

	eliminarUploadedFiles() {
		this.onRemoveSelect();
	}

	/* Confirmacion */
	mostrarConfirmacion(operacion) {
		this.appComponent.showWarn(operacion);
		this.operacion = operacion;
		this.confirmacionVisible = true;
	}

	public mostrarConfirmacionBorrar(){
		console.log("TODO: mostrarConfirmacionBorrar?" + this.tipologiaSeleccionada);
	}

	confirmar() {
		this.confirmacionVisible = false;
		this.msgs = [];
		if (this.operacion === 'guardar') {
			this.guardar();
		}
		else if (this.operacion === 'eliminar') {
			this.eliminar();
		}
	}

	cancelar() {
		this.msgs = [];
		this.operacion = '';
		this.confirmacionVisible = false;
	}

	showWarn(operacion) {
		this.msgs = [];
		if (operacion === 'guardar') {
			this.msgs.push({ severity: 'warn', detail: this.translate.instant('MensajesConfirmacion.MENSAJE_CONFIRMACION_MODIFICAR') });
		}
		else if (operacion === 'eliminar') {
			this.msgs.push({ severity: 'warn', detail: this.translate.instant('MensajesConfirmacion.MENSAJE_CONFIRMACION_ELIMINAR') });
		}
	}

	public eliminar(){
		const that = this;
		const includes = 'CONTENIDOS';
		const where = new Predicate('Id', '==', this.tipologiaSeleccionada.ENTIDAD.Id);

		that.spinner.style.display = 'inherit';
		this.entityManager.getTIPOLOGIA_CONTENIDO(where, includes)
		.then(function(result){
			const tipologia = result;
			if (result.length > 0 && result[0].CONTENIDOS.length > 0) {
				that.msgs.push({ severity: 'warn', detail: that.translate.instant('MensajesConfirmacion.NO_PERMITIDO_ELIMINAR_TIPO_CONTENIDO') });
				that.confirmacionVisible = false;
				that.spinner.style.display = 'none';
			}
			else{
				that.entityManager.deleteTIPOLOGIA_CONTENIDO(result[0])
				// that.entityManager.saveChanges()
				.then(function(){
					that.onElementoEliminado.emit(tipologia);
					that.authService.relogin();
				});
			}
		});
	}

	public guardar(): any {

		const existente = this.tipologiasExistentes.find(t => t.nombre.toLowerCase() === this.tipologiaSeleccionada.Nombre.toLowerCase() && t.id !== this.tipologiaSeleccionada.Id);
		if(!existente){
			this.spinner.style.display = 'inherit';
			if (this.edicion) {
				return this.guardarEdicion();
			}
			else{
				return this.guardarNuevo();
			}
		}else{
			this.msgs = [];
			this.msgs.push({ severity: 'warn', detail: this.translate.instant('MensajesConfirmacion.MENSAJE_TIPOLOGIA_DUPLICADA') });
		}

	}

	public guardarNuevo(){
		const that = this;
		let urlImagenAlaSeleccionada = '';
		this.subirImagenTipologiaSeleccionada(this.imagenTipologiaSeleccionada)
		.then(function(urlImagen) {
			urlImagenAlaSeleccionada = urlImagen;

			return that.entityManager.newTIPOLOGIA_CONTENIDO();
		})
		.then(function (oTIPOLOGIA_CONTENIDO) {

			const idEspacio = that.authService.getIdEspacio();
			oTIPOLOGIA_CONTENIDO.IdEspacio = idEspacio;

			oTIPOLOGIA_CONTENIDO.IDIOMAS.forEach(TIPOLOGIA_CONTENIDO_IDIOMA => {
				const aux = that.tipologiaSeleccionada.Idiomas.get(TIPOLOGIA_CONTENIDO_IDIOMA.IDIOMA.Codigo);

				if(aux){
					TIPOLOGIA_CONTENIDO_IDIOMA.Nombre = aux.Nombre;
					TIPOLOGIA_CONTENIDO_IDIOMA.Descripcion = aux.Descripcion;
				}
				else{
					const espacioIdioma = that.tipologiaSeleccionada.Idiomas.get(that.idiomaDefecto.ENTIDAD.Codigo);
					if(espacioIdioma){
						TIPOLOGIA_CONTENIDO_IDIOMA.Nombre = espacioIdioma.Nombre ? espacioIdioma.Nombre : '';
						TIPOLOGIA_CONTENIDO_IDIOMA.Descripcion = espacioIdioma.Descripcion ? espacioIdioma.Descripcion : '';
					}
				}
			});

			const espacioIdioma = that.tipologiaSeleccionada.Idiomas.get(that.idiomaDefecto.ENTIDAD.Codigo);
			that.tipologiaSeleccionada.Nombre = espacioIdioma.Nombre ? espacioIdioma.Nombre : '';

			oTIPOLOGIA_CONTENIDO.Nombre = that.tipologiaSeleccionada.Nombre;
			oTIPOLOGIA_CONTENIDO.Tipo = that.tipologiaSeleccionada.Tipo;
			oTIPOLOGIA_CONTENIDO.Buscable = that.tipologiaSeleccionada.Buscable;
			oTIPOLOGIA_CONTENIDO.VisibilidadPorDefecto = that.tipologiaSeleccionada.VisibilidadPorDefecto;
			oTIPOLOGIA_CONTENIDO.VisibleEnMapa = that.tipologiaSeleccionada.VisibleEnMapa;
			oTIPOLOGIA_CONTENIDO.MostrableEnDirectorioDeContenidos = that.tipologiaSeleccionada.MostrableEnDirectorioDeContenidos;
			oTIPOLOGIA_CONTENIDO.VisibilidadLabelMapa = that.tipologiaSeleccionada.VisibilidadLabelMapa;
			oTIPOLOGIA_CONTENIDO.VisibilidadIconoMapa = that.tipologiaSeleccionada.VisibilidadIconoMapa;
			oTIPOLOGIA_CONTENIDO.IconoRepresentacion = urlImagenAlaSeleccionada;
			oTIPOLOGIA_CONTENIDO.AnchorPoint = that.tipologiaSeleccionada.anchorPoint.value;
			oTIPOLOGIA_CONTENIDO.VisibilidadListaCOntenidosSeccion = that.tipologiaSeleccionada.VisibilidadListaCOntenidosSeccion;
			oTIPOLOGIA_CONTENIDO.VisibilidadMenuLateral = that.tipologiaSeleccionada.VisibilidadMenuLateral;
			oTIPOLOGIA_CONTENIDO.Activa = that.tipologiaSeleccionada.Activa;

			oTIPOLOGIA_CONTENIDO.VisibilidadListaContenidosWeb = that.tipologiaSeleccionada.VisibilidadListaContenidosWeb;
			oTIPOLOGIA_CONTENIDO.TipoUbicacion = that.tipologiaSeleccionada.TipoUbicacion ? that.tipologiaSeleccionada.TipoUbicacion.value : 'ESTATICO';
			oTIPOLOGIA_CONTENIDO.VisibleSoloEn = Constantes.VISIBLE_SI_UBICADO_EN.SIEMPRE;

			that.tipologiaSeleccionada.Id = oTIPOLOGIA_CONTENIDO.Id;
			that.tipologiaSeleccionada.IconoRepresentacion = oTIPOLOGIA_CONTENIDO.IconoRepresentacion;

			that.tipologiaSeleccionada.ENTIDAD = oTIPOLOGIA_CONTENIDO;


			console.log('tipologia Guardado CORRECTAMENTE = ' + oTIPOLOGIA_CONTENIDO);
			return that.entityManager.saveChanges();
			//return true;
		})
		.then(function(data: any) {
			// Renovamos el Token
			if(data.httpResponse.status === 200){
				that.authService.relogin();
			}
		})
		.then(function () {
			that.onElementoGuardado.emit(that.tipologiaSeleccionada);
		})
		.catch(function (e) {
			that.spinner.style.display = 'none';
			that.onElementoError.emit(that.tipologiaSeleccionada);
		});


	}

	public subirImagenTipologiaSeleccionada(imagenTipologiaSeleccionada) {
		if (imagenTipologiaSeleccionada) {
			// return this.wsServices.subirFicheroCMS(imagenTipologiaSeleccionada, this.tipologiaSeleccionada.Nombre + '.csv').toPromise();
			return this.wsServices.subirFicheroCMS(imagenTipologiaSeleccionada).toPromise();
		}
		else {
			return Promise.resolve('done');
		}
	}

	guardarEdicion(){
		const that = this;
		let urlImagenAlaSeleccionada = '';

		this.guardarMultiIdioma()
		.then(function(){

			const espacioIdioma = that.tipologiaSeleccionada.Idiomas.get(that.idiomaDefecto.ENTIDAD.Codigo);
			that.tipologiaSeleccionada.Nombre = espacioIdioma.Nombre ? espacioIdioma.Nombre : '';

			that.tipologiaSeleccionada.ENTIDAD.Nombre = that.tipologiaSeleccionada.Nombre;
			that.tipologiaSeleccionada.ENTIDAD.Tipo = that.tipologiaSeleccionada.Tipo;
			that.tipologiaSeleccionada.ENTIDAD.Buscable = that.tipologiaSeleccionada.Buscable;
			that.tipologiaSeleccionada.ENTIDAD.VisibilidadPorDefecto = that.tipologiaSeleccionada.VisibilidadPorDefecto;
			that.tipologiaSeleccionada.ENTIDAD.VisibleEnMapa = that.tipologiaSeleccionada.VisibleEnMapa;
			that.tipologiaSeleccionada.ENTIDAD.MostrableEnDirectorioDeContenidos = that.tipologiaSeleccionada.MostrableEnDirectorioDeContenidos;
			that.tipologiaSeleccionada.ENTIDAD.VisibilidadLabelMapa = that.tipologiaSeleccionada.VisibilidadLabelMapa;
			that.tipologiaSeleccionada.ENTIDAD.VisibilidadIconoMapa = that.tipologiaSeleccionada.VisibilidadIconoMapa;
			that.tipologiaSeleccionada.ENTIDAD.AnchorPoint = that.tipologiaSeleccionada.anchorPoint.value;
			that.tipologiaSeleccionada.ENTIDAD.VisibilidadListaCOntenidosSeccion = that.tipologiaSeleccionada.VisibilidadListaCOntenidosSeccion;

			that.tipologiaSeleccionada.ENTIDAD.VisibilidadMenuLateral = that.tipologiaSeleccionada.VisibilidadMenuLateral;
			that.tipologiaSeleccionada.ENTIDAD.Activa = that.tipologiaSeleccionada.Activa;
			that.tipologiaSeleccionada.ENTIDAD.VisibilidadListaContenidosWeb = that.tipologiaSeleccionada.VisibilidadListaContenidosWeb;
			that.tipologiaSeleccionada.ENTIDAD.TipoUbicacion =  that.tipologiaSeleccionada.TipoUbicacion ? that.tipologiaSeleccionada.TipoUbicacion.value : 'ESTATICO';

			if (that.imagenTipologiaSeleccionada) {

				return that.subirImagenTipologiaSeleccionada(that.imagenTipologiaSeleccionada)
				.then(function(urlImagen) {
					urlImagenAlaSeleccionada = urlImagen;

					that.tipologiaSeleccionada.ENTIDAD.IconoRepresentacion = urlImagenAlaSeleccionada;
					that.tipologiaSeleccionada.IconoRepresentacion = urlImagenAlaSeleccionada;


					console.log('tipologia Guardado CORRECTAMENTE = ' + that.tipologiaSeleccionada.ENTIDAD.Nombre);
					that.onElementoGuardado.emit(that.tipologiaSeleccionada);
					return that.entityManager.saveChanges();
				});
			}
			else{

				console.log('tipologia Guardado CORRECTAMENTE = ' + that.tipologiaSeleccionada.ENTIDAD.Nombre);
				that.onElementoGuardado.emit(that.tipologiaSeleccionada);
				return that.entityManager.saveChanges();
			}
		})
		.then(function(data: any) {
			// Renovamos el Token
			if(data.httpResponse.status === 200){
				that.authService.relogin();
			}
		})
		.catch(function (e) {
			that.spinner.style.display = 'none';
			that.onElementoError.emit(that.tipologiaSeleccionada);
		});
	}

	guardarMultiIdioma(){
		const that = this;
		this.entityManager.deleteEntityArray(this.tipologiaSeleccionada.ENTIDAD.IDIOMAS);

		return this.entityManager.newTIPOLOGIA_CONTENIDO_IDIOMA(this.tipologiaSeleccionada.ENTIDAD)
		.then(function(TIPOLOGIA_CONTENIDO_IDIOMAs){

			TIPOLOGIA_CONTENIDO_IDIOMAs.forEach(TIPOLOGIA_CONTENIDO_IDIOMA => {
				const aux = that.tipologiaSeleccionada.Idiomas.get(TIPOLOGIA_CONTENIDO_IDIOMA.IDIOMA.Codigo);
				if (aux) {
					TIPOLOGIA_CONTENIDO_IDIOMA.Nombre = aux.Nombre;
					TIPOLOGIA_CONTENIDO_IDIOMA.Descripcion = aux.Descripcion;
				}

			});

		});
	}

	onIdiomaChange($event) {
		const idioma = $event.value;
		if (!idioma) {
			return;
		}
		this.idiomaSeleccionado = idioma;

		// Cojemos la traduccion del espacio al idioma seleccionado
		let perfilIdioma = this.tipologiaSeleccionada.Idiomas.get(idioma.value);

		// Si no existe la creamos
		if (!perfilIdioma) {

			perfilIdioma = new TipologiaContenidoIdiomaFormulario();

			this.tipologiaSeleccionada.Idiomas.set(idioma.value, perfilIdioma);

		}

		// Seteamos los valores de espacioFormulario con los valores del idioma seleccionado
		this.tipologiaSeleccionada.Nombre = perfilIdioma.Nombre;

		// console.log('Cambiado el Titulo al del idioma: ' + idioma.value + '(' + idioma.title + ')');
	}


	mostrarMiniaturaAla(){
		const hayNuevaImagenSeleccionada = this.imagenTipologiaSeleccionada !== undefined;
		const mostrar = this.tipologiaSeleccionada.IconoRepresentacion && this.tipologiaSeleccionada.IconoRepresentacion !== 'done' && !hayNuevaImagenSeleccionada;
		return mostrar;
	}

	mostrarMiniaturaNoHayImagen(){
		const hayNuevaImagenSeleccionada = this.imagenTipologiaSeleccionada !== undefined;
		const mostrar = !this.mostrarMiniaturaAla() && !hayNuevaImagenSeleccionada;
		return mostrar;
	}
}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/formularios/FormularioTipologiaContenido.component.ts